import { render, staticRenderFns } from "./MuseumTab.vue?vue&type=template&id=349ab5ac&scoped=true"
import script from "./MuseumTab.vue?vue&type=script&lang=js"
export * from "./MuseumTab.vue?vue&type=script&lang=js"
import style0 from "./MuseumTab.vue?vue&type=style&index=0&id=349ab5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "349ab5ac",
  null
  
)

export default component.exports